/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
import React, { useContext, useEffect, useState } from 'react';
import classnames from 'classnames';
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Navbar,
  NavItem,
  Nav,
  Container,
  Row,
  Button,
  Badge,
  Alert
} from 'reactstrap';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowRightCircle, InfoCircle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { getTokenData, isSuperAdmin } from '../../utils/helpers';
import { Store } from '../../Store';

import flagSweden from '../../assets/img/flags/sweden.png';
import flagDenmark from '../../assets/img/flags/denmark.svg';
import flagNorwegian from '../../assets/img/flags/norway.svg';
import flagEngland from '../../assets/img/flags/england.png';
import flagSpain from '../../assets/img/flags/spain.png';
import flagGermany from '../../assets/img/flags/germany.svg';
import i18n from '../../utils/i18n';

let isUserSuperAdmin = false;

function AdminNavbar({ theme, sidenavOpen, toggleSidenav }) {
  const { state } = useContext(Store);
  const { notifications } = state;
  const { number: unhandledWebSales } = state.unhandledWebSales;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [golfclub, setGolfclub] = useState('');

  useEffect(() => {
    isUserSuperAdmin = isSuperAdmin();
    const tokenData = getTokenData();
    setGolfclub(tokenData?.name);
  }, []);

  const changeLanguage = (languageCode) => i18n.changeLanguage(languageCode);

  // function that on mobile devices makes the search open
  // const openSearch = () => {
  //   document.body.classList.add('g-navbar-search-showing');
  //   setTimeout(() => {
  //     document.body.classList.remove('g-navbar-search-showing');
  //     document.body.classList.add('g-navbar-search-show');
  //   }, 150);
  //   setTimeout(() => {
  //     document.body.classList.add('g-navbar-search-shown');
  //   }, 300);
  // };
  // // function that on mobile devices makes the search close
  // const closeSearch = () => {
  //   document.body.classList.remove('g-navbar-search-shown');
  //   setTimeout(() => {
  //     document.body.classList.remove('g-navbar-search-show');
  //     document.body.classList.add('g-navbar-search-hiding');
  //   }, 150);
  //   setTimeout(() => {
  //     document.body.classList.remove('g-navbar-search-hiding');
  //     document.body.classList.add('g-navbar-search-hidden');
  //   }, 300);
  //   setTimeout(() => {
  //     document.body.classList.remove('g-navbar-search-hidden');
  //   }, 500);
  // };

  return (
    <>
      {unhandledWebSales > 0 && (
        <Alert color="warning" isOpen fade style={{ borderRadius: 0 }} className="mb-0">
          <Link to="/golfclub-admin/web-sales/" style={{ color: '#fff' }}>
            <InfoCircle size="30" className="mr-3" />
            {t('web-sales.sales-to-handle', 'Ni har webb-försäljningar som behöver hanteras')}{' '}
            <ArrowRightCircle size="20" className="ml-3" />
          </Link>
        </Alert>
      )}
      <Navbar
        className={classnames(
          'navbar-top navbar-expand border-bottom',
          { 'navbar-dark bg-info': theme === 'dark' },
          { 'navbar-light bg-secondary': theme === 'light' }
        )}
      >
        <Container fluid>
          <Collapse navbar isOpen>
            {/* <Form
              className={classnames(
                'navbar-search form-inline mr-sm-3',
                { 'navbar-search-light': theme === 'dark' },
                { 'navbar-search-dark': theme === 'light' }
              )}
            >
              <FormGroup className="mb-0">
                <InputGroup className="input-group-alternative input-group-merge">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Search" type="text" />
                </InputGroup>
              </FormGroup>
              <button aria-label="Close" className="close" type="button" onClick={closeSearch}>
                <span aria-hidden>×</span>
              </button>
            </Form> */}

            <Nav className="align-items-center ml-md-auto" navbar>
              <NavItem className="d-xl-none">
                <div
                  className={classnames(
                    'pr-3 sidenav-toggler',
                    { active: sidenavOpen },
                    { 'sidenav-toggler-dark': theme === 'dark' }
                  )}
                  onClick={toggleSidenav}
                >
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                    <i className="sidenav-toggler-line" />
                  </div>
                </div>
              </NavItem>
              <NavItem className="d-sm-none">
                {/* <NavLink onClick={openSearch}>
                  <i className="ni ni-zoom-split-in" />
                </NavLink> */}
              </NavItem>
              <UncontrolledDropdown nav style={{ cursor: 'pointer' }}>
                <DropdownToggle className="nav-link" color="" tag="a">
                  {/* <i className="ni ni-bell-55" /> {notifications?.unRead} */}
                  <Button color="default">
                    <i className="ni ni-bell-55" />
                    {notifications?.unRead > 0 && (
                      <span>{t('notifications.unread-messages-title', 'Olästa meddelande')}</span>
                    )}
                    <Badge color="success">{notifications?.unRead}</Badge>
                  </Button>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-xl py-0 overflow-hidden" right>
                  <div className="px-3 py-3">
                    <h6 className="text-sm text-muted m-0">
                      {/* <Trans i18nKey="notifications.unread-messages-text">
                        Du har <strong className="text-info">{notifications?.unRead}</strong> nya
                        meddelanden.
                      </Trans> */}
                      {t('notifications.unread-messages-text', { number: notifications?.unRead })}
                    </h6>
                  </div>

                  <>
                    {notifications.data?.map((n) => (
                      <DropdownItem
                        className="list-group-item-action"
                        onClick={() => navigate('/golfclub-admin/notifications')}
                        tag="a"
                        key={n.id}
                      >
                        <Row className="align-items-center pl-2">
                          {/* <Col className="col-auto">
                          <img
                            alt="..."
                            className="avatar rounded-circle"
                            src={require('../../assets/img/theme/team-1.jpg').default}
                          />
                        </Col> */}
                          <div className="col ml--2">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <h4 className="mb-0 text-sm">{n.title}</h4>
                              </div>
                              <div className="text-right text-muted">
                                <small>{n.date}</small>
                              </div>
                            </div>
                            <p
                              className="text-sm mb-0"
                              // eslint-disable-next-line react/no-danger
                              dangerouslySetInnerHTML={{
                                __html: `${n.message?.substr(0, 30)} ...`
                              }}
                            />
                          </div>
                        </Row>
                      </DropdownItem>
                    ))}
                  </>

                  <DropdownItem
                    className="text-center text-info font-weight-bold py-3"
                    onClick={() => navigate('/golfclub-admin/notifications')}
                  >
                    {t('notifications.view-all', 'Visa alla')}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
            <Nav className="align-items-center ml-auto ml-md-0" navbar>
              <UncontrolledDropdown nav style={{ cursor: 'pointer' }}>
                <DropdownToggle className="nav-link pr-0" color="" tag="a">
                  <Media className="align-items-center">
                    {/* <span className="avatar avatar-sm rounded-circle">
                      <img alt="..." src={require('../../assets/img/theme/team-4.jpg').default} />
                    </span> */}
                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">{golfclub}</span>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0">{t('header.welcome', 'Välkommen')}</h6>
                  </DropdownItem>
                  <DropdownItem
                    href="#pablo"
                    onClick={() => navigate('/golfclub-admin/club-information')}
                  >
                    <i className="ni ni-single-02" />
                    <span>{t('header.club-information', 'Klubb-information')}</span>
                  </DropdownItem>
                  <DropdownItem href="#pablo" onClick={() => navigate('/golfclub-admin/contact')}>
                    <i className="ni ni-support-16" />
                    <span>{t('header.support', 'Support')}</span>
                  </DropdownItem>
                  <DropdownItem divider />
                  {isUserSuperAdmin && (
                    <>
                      <DropdownItem className="noti-title" header tag="div">
                        <h6 className="text-overflow m-0">Språk</h6>
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('sv')}>
                        <img src={flagSweden} alt="sweden flag" style={{ width: '30px' }} /> Svenska
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('da')}>
                        <img src={flagDenmark} alt="denmark flag" style={{ width: '30px' }} />{' '}
                        Danska
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('nb')}>
                        <img src={flagNorwegian} alt="norwegian flag" style={{ width: '30px' }} />{' '}
                        Norska
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('en')}>
                        <img src={flagEngland} alt="english flag" style={{ width: '30px' }} />{' '}
                        Engelska
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('es')}>
                        <img src={flagSpain} alt="spain flag" style={{ width: '30px' }} /> Spanska
                      </DropdownItem>
                      <DropdownItem href="#pablo" onClick={() => changeLanguage('de')}>
                        <img src={flagGermany} alt="germany flag" style={{ width: '30px' }} /> Tyska
                      </DropdownItem>
                      <DropdownItem divider />
                    </>
                  )}
                  <DropdownItem onClick={() => navigate('/golfclub-admin/logout')}>
                    <i className="ni ni-user-run" />
                    <span>{t('header.logout', 'Logga ut')}</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

AdminNavbar.defaultProps = {
  toggleSidenav: () => {},
  sidenavOpen: false,
  theme: 'dark'
};

export default AdminNavbar;
